import request from '@/axios'
import type { UserType, UserLoginType, LoginResponseData } from './types'

interface RoleParams {
  roleName: string
}

// 使用IResponse类型，与现有系统保持一致
export const loginApi = (data: UserLoginType): Promise<IResponse<LoginResponseData>> => {
  return request.post({ url: '/admin/auth/login', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.post({ url: '/admin/auth/logout' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/admin/permission/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/admin/permission/list', params })
}
